'use client';

import React, { useState } from 'react';
import { useRouter } from 'next/navigation';
import {
  Stepper,
  ChoosePlayStep,
  ConfigureStep,
  PreviewStep,
} from './components';
import type { StepId } from './components';

const StrategyBuilder = () => {
  const router = useRouter();
  const [currentStep, setCurrentStep] = useState<StepId>('choose_play');
  const [completedSteps, setCompletedSteps] = useState<StepId[]>([]);

  const handleStepChange = (step: StepId) => {
    setCurrentStep(step);
  };

  const markStepComplete = (step: StepId) => {
    if (!completedSteps.includes(step)) {
      setCompletedSteps([...completedSteps, step]);
    }
  };

  const handlePublish = () => {
    // TODO: Implement publish logic
    markStepComplete('preview');
    router.push('/settings/admin/strategy-manager/target');
  };

  const handleBackToConfigure = () => {
    setCurrentStep('configure');
  };

  const renderStepContent = () => {
    switch (currentStep) {
      case 'choose_play':
        return (
          <ChoosePlayStep onContinue={() => setCurrentStep('configure')} />
        );
      case 'configure':
        return (
          <ConfigureStep
            onBack={() => setCurrentStep('choose_play')}
            onContinue={() => setCurrentStep('preview')}
          />
        );
      case 'preview':
        return (
          <PreviewStep
            onPublish={handlePublish}
            onBack={handleBackToConfigure}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="flex flex-col gap-6" data-testid="strategy-builder">
      {/* Header */}
      <div className="flex flex-col gap-1">
        <h1 className="text-2xl font-bold text-primary">Strategy Builder</h1>
      </div>

      {/* Stepper */}
      <Stepper
        currentStep={currentStep}
        onStepChange={handleStepChange}
        completedSteps={completedSteps}
      />

      {/* Step Content */}
      {renderStepContent()}
    </div>
  );
};

export default StrategyBuilder;
